import type { PriceAdjustment, ProductItem } from './product';

export type CartDigitalDataItem = {
    quantity: number;
};

export type CartDigitalData = {
    cart: {
        item: CartDigitalDataItem[];
    };
};

// Need to check which properties are optional.
export type BasketResponse = {
    fault?: {
        message?: string;
        type?: string;
        arguments?: {
            basketIds?: string;
        };
    };
    adjusted_merchandize_total_tax?: number;
    adjusted_shipping_total_tax?: number;
    basket_id: string;
    c_estimatedTreatsPoints?: number;
    currency: string;
    order_price_adjustments?: PriceAdjustment[];
    order_total: number;
    product_items: ProductItem[];
    product_sub_total: number;
    product_total: number;
    shipping_total: number;
    shipping_total_tax: number;
    tax_rounded_at_group?: boolean;
    tax_total: number;
    availableRewardSummary?: {
        isLoyaltyEnabled: boolean;
    };
    c_cartCount?: number;
    c_digitalData?: CartDigitalData;
};

export type Basket = BasketResponse & {
    product_quantity_total: number;
};

export type ProductData = Partial<ProductItem>[];

export enum AutoShipUnitOfMeasure {
    Days = 1,
    Weeks = 2,
    Months = 3,
}

export type AutoshipParams = {
    productId: string;
    quantity: number;
    unitOfMeasure: number;
    frequencyAmount: number;
};
